import { OptionSubCategory } from 'owa-options-core';
import initSharedCalendarsConfiguration from 'owa-shared-calendars-option/lib/orchestration/initSharedCalendarsConfiguration';
import SharedCalendarsOption from 'owa-shared-calendars-option/lib/SharedCalendarsOption';
import PublishedCalendarsOption from 'owa-shared-calendars-option/lib/PublishedCalendarsOption';

const sharedCalendarsSubCategory: OptionSubCategory = {
    key: 'SharedCalendars',
    titleStringKey: 'optionSubcategory_sharedCalendars',
    options: [SharedCalendarsOption, PublishedCalendarsOption],
    onSelected: initSharedCalendarsConfiguration,
};

export default sharedCalendarsSubCategory;
